module.exports = __webpack_public_path__ + "static/media/compact_fat_squiggle.a72739cf.svg";